import { Database } from "@vuex-orm/core";
import Location from "../models/Location";
import Project from "../models/Project";
import Company from "../models/Company";
import State from "../models/State";
import Industry from "../models/Industry";
import User from "../models/User";
import BatchRawOrigin from "../models/BatchRawOrigin";
import Batch from "../models/Batch";
import Coating from "../models/Coating";
import Manufacturer from "../models/Manufacturer";
import Material from "../models/Material";
import Powder from "../models/Powder";
import RawMaterial from "../models/RawMaterial";
import Supplier from "../models/Supplier";
import Tool from "../models/Tool";
import WorkOrder from "../models/WorkOrder";
import ToolState from "../models/ToolState";
import { BatchMeasurement, RawMeasurement } from "../models/Measurement";
import { BatchTicket, RawTicket } from "../models/Ticket";
import { Shipping, ShippingItem, ShippingMisc } from "../models/Shipping";
import {
  BatchTicketAttachment,
  RawTicketAttachment,
  BatchAttachment,
  WorkOrderAttachment,
  ProjectAttachment,
  MaterialAttachment
} from "../models/Attachment";
import ProjectMaterial from "../models/ProjectMaterial";
import ToolProcess from "../models/ToolProcess";
import ToolStateHistory from "../models/ToolStateHistory";
import ProjectTag from "../models/ProjectTag";

const database = new Database();
database.register(ToolProcess);
database.register(WorkOrderAttachment);
database.register(ProjectAttachment);
database.register(BatchAttachment);
database.register(Location);
database.register(Project);
database.register(Company);
database.register(State);
database.register(Industry);
database.register(User);
database.register(BatchRawOrigin);
database.register(Batch);
database.register(Coating);
database.register(Manufacturer);
database.register(Material);
database.register(Powder);
database.register(RawMaterial);
database.register(Supplier);
database.register(Tool);
database.register(WorkOrder);
database.register(ToolState);
database.register(BatchMeasurement);
database.register(RawMeasurement);
database.register(BatchTicket);
database.register(RawTicket);
database.register(BatchTicketAttachment);
database.register(RawTicketAttachment);
database.register(ShippingItem);
database.register(Shipping);
database.register(MaterialAttachment);
database.register(ShippingMisc);
database.register(ProjectMaterial);
database.register(ToolStateHistory);
database.register(ProjectTag);
export default database;
